import { Link } from "react-router-dom";
import useCommonServices from "../../../../../hooks/useCommonServices";
import { useState } from "react";
import { useSelector } from "react-redux";
import RegistrationStatus from "./RegistrationStatus";

interface SponsorPay {
  onBack: () => void;
  onNext: () => void;
  applicationData: any;
  paymentData: {
    fruitsFee: number;
    othersFee: number;
    totalFee: number;
    selectedOthersCount: number;
    anyFruitsSelected: boolean;
    selectedAPMCsCount: number;
  };
}

const SponsorRegistrationP2 = ({ onBack, onNext, paymentData, applicationData }: SponsorPay) => {
  const {
    fruitsFee,
    othersFee,
    totalFee,
    selectedOthersCount,
    anyFruitsSelected,
    selectedAPMCsCount
  } = paymentData;
    const {doPaymentForCf} = useCommonServices();
  const [paymentType, setPaymentType] = useState("NB");
  const token = useSelector((state: any) => state.auth.token);
  const applicationId = applicationData?.applicationId;
  
   const goTopayment =async () => {
     try {
        
          const res = await doPaymentForCf(applicationId,paymentType,totalFee , token);
          //.log("resss", res.data);

          const htmlText = await res.data.text();

          // Create a temporary container for the form
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = htmlText;

          // Find the form inside the response
          const form = tempDiv.querySelector('form[name="pgposting"]') as HTMLFormElement;

        if (form) {
          document.body.appendChild(form); // Append the form to the body (hidden)
          //.log("Submitting form...");
          form.submit();
        } else {
          //.error("Form not found in response!");
        }
          // const res = await initiatePayment(body , token)
          // //.log('resss', res.data)
          // const htmlText = await res.data.text();
          // setHtmlContent(htmlText);
          

        
        } catch (error) {
          //.error("Error fetching HTML:", error);
        }
    
    
   
   
  };

  return (
    <div>
      <div className="d-flex gap-5 m-5 pt-4 text-nightblue justify-content-center">
        <div className="bg-white p-4 rounded shadow-sm w-100 h-50">
          <h3>Project Summary</h3>
          <div className="border my-3" style={{ height: "1px" }}></div>
          
          <div className="d-flex flex-column gap-4 my-3">
            {/* Show Fruits & Vegetables fee if selected */}
            {anyFruitsSelected && (
              <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0">Fruits & Vegetables (Flat Fee)</p>
                <p>₹{fruitsFee}</p>
              </div>
            )}

            {/* Show Others fee if selected */}
            {selectedOthersCount > 0 && (
              <>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0">Price per APMC (Others)</p>
                  <p>₹500</p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="mb-0">Quantity (APMCs with Others selected)</p>
                  <p>{selectedOthersCount}</p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="mb-0">Others Calculation</p>
                  <p>
                    <span>₹500</span>
                    <span> × </span>
                    <span>{selectedOthersCount}</span>
                    <span> = ₹{othersFee}</span>
                  </p>
                </div>
              </>
            )}
          </div>

          <div className="border my-3" style={{ height: "1px" }}></div>

          <div className="d-flex justify-content-between">
            <h5>Total Payable</h5>
            <h5>₹{totalFee}</h5>
          </div>

          <div className="border my-3" style={{ height: "1px" }}></div>

          <div className="d-flex justify-content-end gap-2 ">
            <button className="btn btn-info px-3" onClick={onBack}>
              Cancel
            </button>
            <button
              className="btn btn-info"
              data-bs-target="#exampleModalToggle"
              data-bs-toggle="modal"
              data-bs-dismiss="modal"
            >
              Pay Now
            </button>
          </div>
        </div>

        <div className="bg-white p-4 rounded shadow-sm w-75">
          <h3>Selection Details</h3>
          
          <div className="d-flex justify-content-between align-content-center gap-4 my-3">
            <p className="mb-0">APMCs Selected</p>
            <p className="bg-light p-1 text-center rounded" style={{ width: "50px" }}>
              {selectedAPMCsCount}
            </p>
          </div>

          {anyFruitsSelected && (
            <div className="d-flex justify-content-between align-content-center gap-4 my-3">
              <p className="mb-0">Fruits & Vegetables</p>
              <p className="bg-success-subtle p-1 text-center rounded" style={{ width: "50px" }}>
                <i className="feather feather-check text-success"></i>
              </p>
            </div>
          )}

          {selectedOthersCount > 0 && (
            <div className="d-flex justify-content-between align-content-center gap-4 my-3">
              <p className="mb-0">APMCs with Others Selected</p>
              <p className="bg-light p-1 text-center rounded" style={{ width: "50px" }}>
                {selectedOthersCount}
              </p>
            </div>
          )}

          <p className="mt-3">
            You can proceed with payment. This list reflects selections from the previous step.
          </p>
        </div>
      </div>

      <div className="w-100">
        <div className="w-100">
          {/* Modal */}
          <div
            className="modal fade"
            id="exampleModalToggle"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel"
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered w-100">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title" id="exampleModalToggleLabel">
                    <i className="feather feather-external-link me-2"></i>
                    Payment Redirect Notice
                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  You will be redirected to a secure payment window to complete your
                  transaction. Please do not close this browser window during the
                  payment process.
                </div>
                <div className="modal-body bg-info-subtle">
                  <p className="m-0 p-0 fw-bold">Important:</p>
                  <br />
                  Keep this window open until payment is complete. You will be
                  redirected back here after successful payment.
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary me-3"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button className="btn btn-info"
                   onClick={goTopayment}>
                    Proceed to Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* /Modal */}
        </div>
      </div>
    </div>
  );
};

export default SponsorRegistrationP2;